import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { TeamsService } from '@brafton/atlas-api-client';
import { People } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'shared-filter-panel-owners-by-team',
  templateUrl: './filter-panel-owners-by-team.component.html',
  styleUrls: ['./filter-panel-owners-by-team.component.scss'],
  host: { class: 'filter-panel-owners-by-team' },
})
export class SharedFilterPanelOwnersByTeamComponent implements OnInit {
  @Input() owners: Filter[] = [];
  @Input() teamId!: number;
  @Output() ownersChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();
  owners$!: Observable<People[]>;

  constructor(private teamsService: TeamsService) { }

  ngOnInit() {
    this.owners$ = this.teamsService.ListMembers(this.teamId).pipe(switchMap((m: People[]) => this.teamsService.getTeam(this.teamId).pipe(map((r: People) => m.concat(r)))));
  }

  add(ownerDef: People) {
    if (!this.owners.find((sp) => sp.value === ownerDef.id.toString())) {
      this.owners.push({ value: ownerDef.id, displayName: ownerDef.displayName, type: 'user' } as Filter);
    }
    this.ownersChange.emit(this.owners);
  }

  remove(ownerDef: People) {
    const index = this.owners.findIndex((sp) => sp.value === ownerDef.id.toString());
    if (index > -1) {
      this.owners.splice(index, 1);
    }
    this.ownersChange.emit(this.owners);
  }

  clear() {
    this.owners = [];
    this.ownersChange.emit(this.owners);
  }

  isSelected(ownerDef: People): boolean {
    if (!this.owners) return false;
    if (this.owners.find((sp) => sp.value === ownerDef.id.toString())) return true;
    else return false;
  }
}
